import {useState, useCallback} from 'react';

const useDeleteConfirm = () => {
    const [open, setOpen] = useState(false);
    const openDialog = useCallback(() => setOpen(true), []);
    const closeDialog = useCallback(() => setOpen(false), []);
    return {open, openDialog, closeDialog};
};

export default useDeleteConfirm;
